import React, { useRef, useState, useEffect } from 'react';
import Tesseract from 'tesseract.js';
import Webcam from 'react-webcam';
import './zonescan.css';
import { useNavigate } from 'react-router-dom';

const Zonescan = () => {
  const webcamRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      captureAndScan();
    }, 5000); // scan every 5 seconds

    return () => clearInterval(interval); // cleanup when component unmounts
  }, []);

  const captureAndScan = async () => {
    if (loading || !webcamRef.current) return;

    const imageSrc = webcamRef.current.getScreenshot();
    if (!imageSrc) {
      console.warn("Camera not ready.");
      return;
    }

    setLoading(true);
    setShowNotification(false);

    try {
      const result = await Tesseract.recognize(imageSrc, 'eng', {
        logger: m => console.log(m),
      });
      const text = result.data.text.toLowerCase();
      console.log("OCR Detected Text:", text);

      if (text.includes("z1")) navigate('/zones', { state: { zone: 'z1' } });
      else if (text.includes("z2")) navigate('/zones', { state: { zone: 'z2' } });
      else if (text.includes("z3")) navigate('/zones', { state: { zone: 'z3' } });
      else if (text.includes("z4")) navigate('/zones', { state: { zone: 'z4' } });
      else if (text.includes("z5")) navigate('/zones', { state: { zone: 'z5' } });
      else setShowNotification(true);
    } catch (err) {
      console.error("OCR error:", err);
      setShowNotification(true);
    }

    setLoading(false);
  };

  return (
    <div className="zonescan-container">
      <h1 className="zonescan-title">📡 Auto-Scanning Zone Code (Z1–Z5)</h1>
      <div className="webcam-zone-wrapper">
        <Webcam
          audio={false}
          ref={webcamRef}
          screenshotFormat="image/png"
          width={340}
          height={260}
          videoConstraints={{ facingMode: "environment" }}
          className="webcam-feed"
        />

        {loading && <p>🔄 Scanning...</p>}

        {showNotification && (
          <div className="zone-alert">
            ❌ Scan failed. Please ensure code like <strong>Z1</strong> is visible.
          </div>
        )}
      </div>

      <button
        onClick={() => window.location.href = "/zones"}
        className="goback-button"
      >
        ⬅️ Go Back
      </button>
    </div>
  );
};

export default Zonescan;
